/**
 * Bundled branding fallbacks for specific studios.
 *
 * The storefront/console normally renders `tenant.logo_url` (set by the studio
 * in Studio → Branding). This map provides an app-bundled logo/icon fallback
 * for known studios that haven't set a `logo_url` yet.
 *
 * - `iconUrl`  : square mark (idli) — used for favicons / tight square slots.
 * - `logoUrl`  : full lockup (mark + wordmark typography) — used in headers.
 * - `wordmark` : true when `logoUrl` already contains the studio name, so the
 *                separate text name should be hidden to avoid duplication.
 *
 * Assets live in `/public/branding/` and are served from the site root.
 */
export const STUDIO_BRANDING = {
  idlichutnee: {
    iconUrl: "/branding/idli-chutnee-icon.png",
    logoUrl: "/branding/idli-chutnee-logo.png",
    wordmark: true,
  },
};

export function studioBranding(slug) {
  if (!slug) return null;
  return STUDIO_BRANDING[slug] || null;
}
